import * as z from "zod";

export const commerceAgentHighlights = {
  name: "commerceAgentHighlights" as const,
  input: z.object({
    limit: z.number().int().min(1).max(50).default(10),
    /** Jev's P(standout) a highlight must reach, 0.5 to 1. */
    minScore: z.number().min(0.5).max(1).default(0.5),
    /** How many days back to look; the best-scoring highlights in that window come first. */
    days: z.number().int().min(1).max(90).default(7),
  }),
  output: z.object({
    highlights: z.array(
      z.object({
        id: z.string(),
        channelThreadId: z.string(),
        /** Opens the conversation: the Commerce Agent conversations page's `selected` query param. */
        conversationTopicId: z.string(),
        score: z.number(),
        createdAt: z.date(),
        messages: z.array(
          z.object({
            id: z.string(),
            role: z.enum(["customer", "agent"]),
            content: z.string(),
            sentAt: z.date(),
          }),
        ),
      }),
    ),
  }),
};
